export default __webpack_public_path__ + "static/email-bg-f2af59a4a4e2837d835ac44a647c9b93.png";